/**
 * <tws-winners-wall> — the winners wall.
 *
 * On small screens the wall is a horizontal, snapping scroller. This element
 * only mirrors that scroll position onto the progress bar underneath it; the
 * scroller itself is plain CSS, so with no JavaScript the wall still works and
 * the bar simply stays put. Above the mobile breakpoint the track is a masonry
 * grid that never overflows, and the bar is hidden by CSS.
 */
class TwsWinnersWall extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-winners-track]');
    this.thumb = this.querySelector('[data-winners-thumb]');
    if (!this.track || !this.thumb) return;

    this.update = this.update.bind(this);
    this.track.addEventListener('scroll', this.update, { passive: true });

    // Layout changes (breakpoint, images loading) move the thumb too.
    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
    }

    this.update();
  }

  disconnectedCallback() {
    if (this.track) this.track.removeEventListener('scroll', this.update);
    if (this.observer) this.observer.disconnect();
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const scrollable = scrollWidth - clientWidth;

    if (scrollable <= 0) {
      this.thumb.style.width = '100%';
      this.thumb.style.transform = 'translateX(0)';
      return;
    }

    // The thumb takes the same share of the bar that the viewport takes of the
    // track, then travels the leftover width in step with the scroll.
    const ratio = clientWidth / scrollWidth;
    const progress = scrollLeft / scrollable;

    this.thumb.style.width = `${ratio * 100}%`;
    this.thumb.style.transform = `translateX(${progress * (1 / ratio - 1) * 100}%)`;
  }
}

customElements.define('tws-winners-wall', TwsWinnersWall);
